/**
 * Labstep
 */

import { AccessKeyManager } from 'labstep-web/components/AccessKey/Manager';
import { Container } from 'labstep-web/components/Layout/Container';
import { UserSettingsEmail as Email } from 'labstep-web/components/User/Settings/Email';
import { UserSettingsLoginSecurity } from 'labstep-web/components/User/Settings/LoginSecurity';
import { UserSettingsMfa as UserSettingsMFA } from 'labstep-web/components/User/Settings/Mfa';
import type { User } from 'labstep-web/models/user.model';

export const getLinks = (user: User) => {
  const links = [
    {
      key: 'General',
      render: () => (
        <div>
          <Container>
            <Email user={user} />
          </Container>
          {!user.is_external && (
            <>
              <Container>
                <UserSettingsLoginSecurity />
              </Container>
              <Container>
                <UserSettingsMFA user={user} />
              </Container>
            </>
          )}
        </div>
      ),
    },
    {
      key: 'API',
      render: () => <AccessKeyManager />,
    },
  ];

  return links;
};
